// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1991": "c4168a9b53e0","4496": "95baf2e8fce3","5015": "59cf926dd644","5099": "26d5541101b8","5508": "fc07ce016ed5","6326": "07fdbe671f01","7441": "29ffd045717e","7796": "ef46db3751d8","8448": "8f0b63be48fc",}[chunkId] + ".css"
}